class ShareError extends Error {
  constructor(message) {
    super(message);
    this.name = "ShareError";
  }
}
async function uploadToHuggingFace(data, type) {
  if (window.__gradio_space__ == null) {
    throw new ShareError("Must be on Spaces to share.");
  }
  let blob;
  let contentType;
  let filename;
  {
    let url;
    if (typeof data === "object" && data.url) {
      url = data.url;
    } else if (typeof data === "string") {
      url = data;
    } else {
      throw new Error("Invalid data format for URL type");
    }
    const response = await fetch(url);
    blob = await response.blob();
    contentType = response.headers.get("content-type") || "";
    filename = response.headers.get("content-disposition") || "";
  }
  const file = new File([blob], filename, { type: contentType });
  const uploadResponse = await fetch("https://huggingface.co/uploads", {
    method: "POST",
    body: file,
    headers: {
      "Content-Type": file.type,
      "X-Requested-With": "XMLHttpRequest"
    }
  });
  if (!uploadResponse.ok) {
    if (uploadResponse.headers.get("content-type")?.includes("application/json")) {
      const error = await uploadResponse.json();
      throw new ShareError(`Upload failed: ${error.error}`);
    }
    throw new ShareError(`Upload failed.`);
  }
  const result = await uploadResponse.text();
  return result;
}
const format_time = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const seconds_remainder = Math.round(seconds) % 60;
  const padded_minutes = `${minutes < 10 ? "0" : ""}${minutes}`;
  const padded_seconds = `${seconds_remainder < 10 ? "0" : ""}${seconds_remainder}`;
  if (hours > 0) {
    return `${hours}:${padded_minutes}:${padded_seconds}`;
  }
  return `${minutes}:${padded_seconds}`;
};
const is_browser = typeof window !== "undefined";
class Gradio {
  #id;
  theme;
  version;
  i18n;
  #el;
  root;
  autoscroll;
  max_file_size;
  client;
  _load_component;
  load_component = _load_component.bind(this);
  constructor(id, el, theme, version, root, autoscroll, max_file_size, i18n = (x) => x, client, virtual_component_loader) {
    this.#id = id;
    this.theme = theme;
    this.version = version;
    this.#el = el;
    this.max_file_size = max_file_size;
    this.i18n = i18n;
    this.root = root;
    this.autoscroll = autoscroll;
    this.client = client;
    this._load_component = virtual_component_loader;
  }
  dispatch(event_name, data) {
    if (!is_browser || !this.#el)
      return;
    const e = new CustomEvent("gradio", {
      bubbles: true,
      detail: { data, id: this.#id, event: event_name }
    });
    this.#el.dispatchEvent(e);
  }
}
function _load_component(name, variant = "component") {
  return this._load_component({
    name,
    api_url: this.client.config?.root,
    variant
  });
}
const css_units = (dimension_value) => {
  return typeof dimension_value === "number" ? dimension_value + "px" : dimension_value;
};
export {
  Gradio as G,
  css_units as c,
  format_time as f,
  uploadToHuggingFace as u
};
